import React from 'react';
import SVG from 'react-inlinesvg';
import { Link, Text } from '@perch-labs/shrike';
import { Card, Container } from 'styles';
import { vnmExplainerGuide } from 'domain/vnm';
import Graphic from '/images/solar/circled-solar-panel.svg';
import { copyFor } from 'config';
import { SPONSORED_SOLAR } from 'pages/dashboard/dashboard.utils';

const getCopy = copyFor('solar.welcome');
const statePlaceholder = getCopy('statePlaceholder');

interface Props {
  children?: React.ReactNode;
  state: string;
  originationSourceType?: string;
}

export const Welcome = (props: Props) => {
  const { children, state = statePlaceholder, originationSourceType } = props;
  const subtitle = children
    ? getCopy('subTitle', { state })
    : getCopy('altCopy', { state });
  const sponsoredSolar = originationSourceType === SPONSORED_SOLAR;
  return (
    <Card mobileVariant="flat">
      <Card.Content>
        <Container flex justifyContent="center" padding={{ top: '40px' }}>
          <SVG src={Graphic} width="400" />
        </Container>
        <Text
          textStyle="heading700"
          tag="h1"
          margin={{ bottom: '24px', top: '8px' }}
        >
          {sponsoredSolar ? getCopy('sponsoredSolarTitle') : getCopy('title')}
        </Text>
        <Text margin={{ bottom: '24px' }}>
          {sponsoredSolar
            ? getCopy('sponsoredSolarSubTitle', { state })
            : subtitle}{' '}
          <Link type="inline" href={vnmExplainerGuide}>
            {sponsoredSolar ? '' : getCopy('link')}
          </Link>
          {sponsoredSolar ? '' : '.'}
        </Text>
        {children}
      </Card.Content>
    </Card>
  );
};
